export default function Tysiav2NotificationAnimatedIcon({
  size = 14,
  color = 'white',
  times = 5,
  className,
  style,
  ...rest
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.76302 0.312557C4.00465 0.648995 3.92778 1.11761 3.59135 1.35923C2.94459 1.82372 2.41763 2.43542 2.05399 3.1438C1.69034 3.85218 1.50045 4.63691 1.5 5.43318C1.49977 5.84739 1.16379 6.18299 0.749575 6.18275C0.335362 6.18252 -0.000234302 5.84654 1.2274e-07 5.43233C0.000585917 4.3981 0.247225 3.37885 0.719545 2.45877C1.19186 1.53869 1.87631 0.744183 2.71635 0.140882C3.05278 -0.100742 3.5214 -0.0238812 3.76302 0.312557ZM3.81802 2.56808C4.66193 1.72417 5.80653 1.25006 7 1.25006C8.19347 1.25006 9.33807 1.72417 10.182 2.56808C11.0259 3.41199 11.5 4.55659 11.5 5.75006V9.25006C11.5 9.51528 11.6054 9.76963 11.7929 9.95717C11.9804 10.1447 12.2348 10.2501 12.5 10.2501C12.7761 10.2501 13 10.474 13 10.7501C13 11.0262 12.7761 11.2501 12.5 11.2501H1.5C1.22386 11.2501 1 11.0262 1 10.7501C1 10.474 1.22386 10.2501 1.5 10.2501C1.76522 10.2501 2.01957 10.1447 2.20711 9.95717C2.39464 9.76963 2.5 9.51528 2.5 9.25006V5.75006C2.5 4.55659 2.97411 3.41199 3.81802 2.56808ZM5.25 13.2501C5.25 12.8359 5.58579 12.5001 6 12.5001H8C8.41421 12.5001 8.75 12.8359 8.75 13.2501C8.75 13.6643 8.41421 14.0001 8 14.0001H6C5.58579 14.0001 5.25 13.6643 5.25 13.2501ZM11.2837 0.140882C10.9472 -0.100742 10.4786 -0.0238812 10.237 0.312557C9.99536 0.648995 10.0722 1.11761 10.4087 1.35923C11.0554 1.82372 11.5824 2.43542 11.946 3.1438C12.3097 3.85218 12.4996 4.63691 12.5 5.43318C12.5002 5.84739 12.8362 6.18299 13.2504 6.18275C13.6646 6.18252 14.0002 5.84654 14 5.43233C13.9994 4.3981 13.7528 3.37885 13.2805 2.45877C12.8081 1.53869 12.1237 0.744183 11.2837 0.140882Z"
          fill={color}
        />
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          values="0 7 7; 20 7 7; 0 7 7; -20 7 7; 0 7 7"
          keyTimes="0; 0.25; 0.5; 0.75; 1"
          dur="0.4s"
          begin="0s"
          repeatCount={times}
          calcMode="linear"
        />
      </g>
    </svg>
  )
}
